import { render, staticRenderFns } from "./simpleSnotifysuccess.vue?vue&type=template&id=542dd316&scoped=true"
import script from "./simpleSnotifysuccess.vue?vue&type=script&scoped=true&lang=js"
export * from "./simpleSnotifysuccess.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./simpleSnotifysuccess.vue?vue&type=style&index=0&id=542dd316&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542dd316",
  null
  
)

export default component.exports